import React from 'react';
import PropTypes from 'prop-types';

import { withBrand } from '../../../../../../providers/BrandProvider';

import './ProductPopup.scss';

export function ProductPopup(props) {
  const { heading, body, brand: { secondaryColor } = {}, closeModal } = props;

  return (
    <div className="c-product-popup">
      <div
        className="c-product-popup__header"
        style={{ backgroundColor: secondaryColor }}
      >
        <div className="c-product-popup__close" onClick={closeModal}>
          ×<span>Close</span>
        </div>
      </div>
      <div className="c-product-popup__body">
        {heading && <h3 className="c-product-popup__heading">{heading}</h3>}
        {body && <div>{body}</div>}
      </div>
    </div>
  );
}

ProductPopup.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  closeModal: PropTypes.func,
  brand: PropTypes.shape({
    secondaryColor: PropTypes.string,
  }),
};

export default withBrand(ProductPopup);
